import React from 'react';
import { ApLoaderDefault } from '@alixpartners/ui-components';
import { CardText, CardValue, KpiCard, Wrapper } from './KpiList.styles';
import { useAnalyzeEditDataContext } from 'contexts/SupplierDiversity/AnalyzeEditDataProvider';
import { formatNumber, formatSpendWithDecimalAndSymbol } from 'utils/number';

const KpiElement = ({ data, isLoading, isLeft }) => {
	return (
		<KpiCard isLeft={isLeft}>
			{isLoading ? (
				<ApLoaderDefault />
			) : (
				<Wrapper>
					<div>
						<CardValue>{data.value1}</CardValue>
						<CardText>{data.text1}</CardText>
					</div>
					<div>VS</div>
					<div>
						<CardValue>{data.value2}</CardValue>
						<CardText>{data.text2}</CardText>
					</div>
				</Wrapper>
			)}
		</KpiCard>
	);
};

const KpiList = ({ currencySymbol, hideDecimals }) => {
	const { kpi } = useAnalyzeEditDataContext();
	const { isFetching, data } = kpi;
	return (
		<>
			<KpiElement
				data={{
					text1: 'Total Client Spend',
					value1: formatSpendWithDecimalAndSymbol(
						data.total_spend_analysis,
						currencySymbol,
						hideDecimals,
						2
					).toUpperCase(),
					text2: 'Total Diversity Spend',
					value2: formatSpendWithDecimalAndSymbol(
						data.total_spend_central,
						currencySymbol,
						hideDecimals,
						2
					).toUpperCase(),
				}}
				isLoading={isFetching}
				isLeft={true}
			/>
			<KpiElement
				data={{
					text1: 'Total Client Suppliers',
					value1: formatNumber(data.total_vendor_count_analysis),
					text2: 'Total Diversity Suppliers',
					value2: formatNumber(data.total_vendor_count_central),
				}}
				isLoading={isFetching}
				isLeft={false}
			/>
		</>
	);
};

export default KpiList;
